import { Injectable } from "@angular/core";
import { Breadcrumb } from "@core/models/breadcrumb/breadcrumb.model";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { AppendBrandAction, AppendProductNameAction, ResetBrandAction, SetBreadcrumbAction } from "./breadcrumb.actions";


export class BreadcrumbStateModel {
    public breadcrumbItems: Breadcrumb[];
    public currentBrand: Breadcrumb;
}

@State<BreadcrumbStateModel>({
    name: 'breadcrumb',
    defaults: {
        breadcrumbItems: [],
        currentBrand: null,
    }
})

@Injectable()
export class BreadcrumbState {
    constructor(
    ) { }


    @Selector()
    static getItems(state: BreadcrumbStateModel) {
        return state.breadcrumbItems
    }

    @Selector()
    static getCurrentBrand(state: BreadcrumbStateModel) {
        return state.currentBrand
    }

    @Action(AppendBrandAction)
    appendBrandAction({ dispatch, patchState, getState }: StateContext<BreadcrumbStateModel>, action: AppendBrandAction) {
        const state = getState().breadcrumbItems
        const b = new Breadcrumb(action.payload.brand, action.payload.url, true, false)
        patchState({
            breadcrumbItems: [...state.filter(x => !x.isBrand), b],
            currentBrand: b
        });
    }

    @Action(AppendProductNameAction)
    appendProductNameAction({ dispatch, patchState, getState }: StateContext<BreadcrumbStateModel>, action: AppendProductNameAction) {
        const state = getState().breadcrumbItems
        // if (!getState().currentBrand) {
        //     patchState({
        //         breadcrumbItems: [...state.filter(x => x.text !== action.payload.id), ...[new Breadcrumb(action.payload.productName, state[0].currentUrl, false, true)]]
        //     });
        //     return;
        // }
        patchState({
            breadcrumbItems: [...state.map((m) => m.text === action.payload.id ? new Breadcrumb(action.payload.productName, m.currentUrl, false, true) : m)]
        })
    }

    @Action(SetBreadcrumbAction)
    setBreadcrumbAction({ dispatch, patchState, getState }: StateContext<BreadcrumbStateModel>, action: SetBreadcrumbAction) {
        const state = getState();

        patchState({
            breadcrumbItems: action.payload.breadcrumbs
        })

        // if (state.currentBrand) {
        //     patchState({
        //         breadcrumbItems: [...state.breadcrumbItems, state.currentBrand]
        //     });
        // }
    }

    @Action(ResetBrandAction)
    resetBrandAction({ dispatch, patchState }: StateContext<BreadcrumbStateModel>, action: ResetBrandAction) {
        patchState({
            currentBrand: null
        });
    }
}
